import translate from '../functions/translate';
import H2 from './h2';

interface StepHeaderProps {
    currentStep: number
    numSteps: number
    stepTitle: string
}

const StepHeader = (props: StepHeaderProps) => {
    const {currentStep, numSteps, stepTitle} = props;
    return <>
        <legend>
            <p className='ds-text-heading--sm'>{translate('step_of', { step: currentStep, steps: numSteps})}</p>
            <H2 className={'ds-u-margin-top--0'}>{stepTitle}</H2>
        </legend>
    </>;
};

export default StepHeader;